'use strict'

const stickyHeaderBar = require('../stickyHeaderBar/stickyHeaderBar.js');

module.exports = (function () {
    /**
    * @ngdoc method
    * @name mobileNav
    * @description Initializes custom navigation behavior
    **/

    var initialize = function () {
        var check = $('#primaryNav li > ul');
        $(check).not(":has('li')").addClass('no-children');

        initializeMobileNav();
        initializeDesktopNav();

        // CURRENT LINK DISPLAY
        $('#primaryNav ul > li.current').parent().addClass('menu');
    }

    var initializeMobileNav = function () {

        // MOBILE NAVIGATION DRAWER
        $('header .fa-bars').on('click', function () {
            $('body').attr('data-nav-drawer', $('body').attr('data-nav-drawer') == 'closed' ? 'open' : 'closed');
            $(this).toggleClass('fa-bars').toggleClass('fa-close');
        });

        $('.navMenuItem .primaryNavSection').on('click', function () {
            $(this).find('span').toggleClass('show').find('+ ul').toggleClass('show');
        });

        $('.primaryNavMenu .primaryNavSection ul li a').on('click', function () {
            $('body').attr('data-nav-drawer', $('body').attr('data-nav-drawer') == 'closed' ? 'open' : 'closed');
            $('header .fa-close').toggleClass('fa-close').toggleClass('fa-bars');
        });

        $('#primaryNavMobile nav#topNav ul li a').on('click', function () {
            $('body').attr('data-nav-drawer', $('body').attr('data-nav-drawer') == 'closed' ? 'open' : 'closed');
            $('header .fa-close').toggleClass('fa-close').toggleClass('fa-bars');
        });

        $('#primaryNavMobile ul#onlineBanking li a').on('click', function () {
            $('body').attr('data-nav-drawer', $('body').attr('data-nav-drawer') == 'closed' ? 'open' : 'closed');
            $('header .fa-close').toggleClass('fa-close').toggleClass('fa-bars');
        });

        // SHOW MENU FROM ANCHORED BAR

        $('.hamburger i').on('click', function () {
            $(this).toggleClass('fa-bars fa-close');
            $('header[role="banner"], nav#primaryNav').toggleClass('fixed');

            var currentPosition = $(window).scrollTop().valueOf();

            $(window).on('scroll', function () {
                if ($(window).scrollTop() > currentPosition + 300) {
                    //console.log('current position + 300 from top');
                    $('header[role="banner"], nav#primaryNav').removeClass('fixed');

                    if ($('.hamburger i').hasClass('fa-close')) {
                        $('.hamburger i').removeClass('fa-close');
                        $('.hamburger i').addClass('fa-bars');
                    }
                }
            });
        });
    }

    var initializeDesktopNav = function () {
        stickyHeaderBar.initialize();
    }

    return {
        initialize: initialize
    };
}())